'use client'

import CommentComposer from '@/features/veluvit/components/comments/comment-composer'
import CommentList from '@/features/veluvit/components/comments/comment-list'
import { useWorkComments } from '@/features/veluvit/components/comments/use-work-comments'
import DetailBox from '@/features/veluvit/components/detail/detail-box'
import { useRoom } from '@/features/veluvit/stores/session.store'

/**
 * 작품 상세 댓글 칸 — 쓰기(스냅 붙이기 포함) + 목록(답글 접기 · 좋아요 · 내 것 수정/삭제 · 남의 것 신고).
 * 목록 · 쓰기 · 동작은 탐색 댓글 패널과 같은 부품(components/comments)이다. 작가가 댓글을 닫은 작품은 칸째 숨긴다.
 */
export default function CommentsBox({ id }: { id: string }) {
  const c = useWorkComments(id)
  const room = useRoom(id)
  if (c.closed) return null
  return (
    <DetailBox title="댓글" sub={c.items ? `${c.total}개` : undefined}>
      <CommentComposer
        c={c}
        snapRoom={room ? { id: room.id, snaps: room.snaps || [] } : undefined}
        className="mt-4"
      />
      <CommentList c={c} className="mt-6" />
    </DetailBox>
  )
}
